"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validation = exports.forbidden = exports.unauthorized = exports.unknown = exports.TechnicalAladinErrorType = void 0;
const error_1 = require("./error");
var TechnicalAladinErrorType;
(function (TechnicalAladinErrorType) {
    TechnicalAladinErrorType["UNKNOWN"] = "technical.unknown";
    TechnicalAladinErrorType["UNAUTHORIZED"] = "technical.unauthorized";
    TechnicalAladinErrorType["FORBIDDEN"] = "technical.forbidden";
    TechnicalAladinErrorType["VALIDATION"] = "technical.validation";
})(TechnicalAladinErrorType = exports.TechnicalAladinErrorType || (exports.TechnicalAladinErrorType = {}));
function unknown(message = 'Unknown Error', reasons) {
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.UNKNOWN,
        message,
        details: reasons ? { reasons } : undefined
    });
}
exports.unknown = unknown;
function unauthorized(message = 'Client not authenticated') {
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.UNAUTHORIZED,
        message
    });
}
exports.unauthorized = unauthorized;
function forbidden(message = 'Client is missing permissions') {
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.FORBIDDEN,
        message
    });
}
exports.forbidden = forbidden;
function validation(param1, param2) {
    let message = 'Validation Error';
    let reasons = [];
    if (typeof param1 === 'string') {
        message = param1;
    }
    if (param2 !== undefined) {
        reasons = param2;
    }
    return new error_1.AladinError({
        key: TechnicalAladinErrorType.VALIDATION,
        message,
        details: {
            reasons
        }
    });
}
exports.validation = validation;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9oZWxwZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFxQztBQUVyQyxJQUFZLHdCQUtYO0FBTEQsV0FBWSx3QkFBd0I7SUFDbEMseURBQTZCLENBQUE7SUFDN0IsbUVBQXVDLENBQUE7SUFDdkMsNkRBQWlDLENBQUE7SUFDakMsK0RBQW1DLENBQUE7QUFDckMsQ0FBQyxFQUxXLHdCQUF3QixHQUF4QixnQ0FBd0IsS0FBeEIsZ0NBQXdCLFFBS25DO0FBRUQsU0FBZ0IsT0FBTyxDQUFDLE9BQU8sR0FBRyxlQUFlLEVBQUUsT0FBaUI7SUFDbEUsT0FBTyxJQUFJLG1CQUFXLENBQUM7UUFDckIsR0FBRyxFQUFFLHdCQUF3QixDQUFDLE9BQU87UUFDckMsT0FBTztRQUNQLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQyxDQUFDLEVBQUUsT0FBTyxFQUFFLENBQUMsQ0FBQyxDQUFDLFNBQVM7S0FDM0MsQ0FBQyxDQUFBO0FBQ0osQ0FBQztBQU5ELDBCQU1DO0FBRUQsU0FBZ0IsWUFBWSxDQUFDLE9BQU8sR0FBRywwQkFBMEI7SUFDL0QsT0FBTyxJQUFJLG1CQUFXLENBQUM7UUFDckIsR0FBRyxFQUFFLHdCQUF3QixDQUFDLFlBQVk7UUFDMUMsT0FBTztLQUNSLENBQUMsQ0FBQTtBQUNKLENBQUM7QUFMRCxvQ0FLQztBQUNELFNBQWdCLFNBQVMsQ0FBQyxPQUFPLEdBQUcsK0JBQStCO0lBQ2pFLE9BQU8sSUFBSSxtQkFBVyxDQUFDO1FBQ3JCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxTQUFTO1FBQ3ZDLE9BQU87S0FDUixDQUFDLENBQUE7QUFDSixDQUFDO0FBTEQsOEJBS0M7QUFJRCxTQUFnQixVQUFVLENBQUMsTUFBeUMsRUFBRSxNQUFpQztJQUNyRyxJQUFJLE9BQU8sR0FBRyxrQkFBa0IsQ0FBQTtJQUNoQyxJQUFJLE9BQU8sR0FBNkIsRUFBRSxDQUFBO0lBQzFDLElBQUcsT0FBTyxNQUFNLEtBQUssUUFBUSxFQUFFO1FBQzdCLE9BQU8sR0FBRyxNQUFNLENBQUE7S0FDakI7SUFDRCxJQUFHLE1BQU0sS0FBSyxTQUFTLEVBQUU7UUFDdkIsT0FBTyxHQUFHLE1BQU0sQ0FBQTtLQUNqQjtJQUNELE9BQU8sSUFBSSxtQkFBVyxDQUFDO1FBQ3JCLEdBQUcsRUFBRSx3QkFBd0IsQ0FBQyxVQUFVO1FBQ3hDLE9BQU87UUFDUCxPQUFPLEVBQUU7WUFDUCxPQUFPO1NBQ1I7S0FDRixDQUFDLENBQUE7QUFDSixDQUFDO0FBaEJELGdDQWdCQyJ9